import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ZoneButton from './ZoneButton';
import ZoneButtonsWrapper from './ZoneButtonsWrapper';
import {
  getRelativeHeight,
  getRelativeWidth,
} from '../../components/CardReader/CardReader';

const ButtonCD = styled(ZoneButton)`
  height: 100%;
  margin-top: 2%;
  margin-left: 36%;
  width: 37%;
`;

const ButtonD = styled(ZoneButton)`
  margin-left: 52%;
  width: 18%;
`;

const ButtonDummy = styled(ZoneButton)`
  margin-top: ${getRelativeHeight(-4)};
  width: 0;
`;

const UpButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 9%;
  right: ${getRelativeHeight(5)};
  height: ${getRelativeHeight(52)};
  width: ${getRelativeWidth(390)};
  margin-bottom: ${getRelativeHeight(7)};
`;

const UpButton = styled(ZoneButton)`
  height: ${getRelativeHeight(266)};
  width: ${getRelativeWidth(65)};
  cursor: pointer;
`;

const ZoneButtonsD2 = ({ onClickZoneCD, onClickZoneD, onClickUpButton }) => (
  <ZoneButtonsWrapper>
    <UpButtonWrapper>
      <ButtonCD onClick={onClickZoneCD} />
      <UpButton onClick={onClickUpButton} />
    </UpButtonWrapper>
    <ButtonD onClick={onClickZoneD} />
    <ButtonDummy onClick={() => false} />
  </ZoneButtonsWrapper>
);

ZoneButtonsD2.propTypes = {
  onClickZoneCD: PropTypes.func.isRequired,
  onClickZoneD: PropTypes.func.isRequired,
  onClickUpButton: PropTypes.func.isRequired,
};

export default ZoneButtonsD2;
